import { Payment, Result, Overview } from './index';

import payment from '../assets/svg/payment.svg';
import paymentActive from '../assets/svg/payment-active.svg';
import summary from '../assets/svg/summary-active.svg';
import result from '../assets/svg/result.svg';
import resultActive from '../assets/svg/result-active.svg';

import { SECTION_HEADERS } from '../utils/constants';

export const steps = [
	{
		component: Overview,
		title: 'Özet',
		header: SECTION_HEADERS.PAYMENT_INFO,
		stepIcon: <img src={summary} alt="summary" />,
		activeStepIcon: <img src={summary} alt="summary" />
	},
	{
		component: Payment,
		title: 'Ödeme',
		header: SECTION_HEADERS.PAYMENT_OPTIONS,
		stepIcon: <img src={payment} alt="payment" />,
		activeStepIcon: <img src={paymentActive} alt="payment-active" />
	},
	{
		component: Result,
		title: 'Sonuç',
		header: '',
		stepIcon: <img src={result} alt="result" />,
		activeStepIcon: <img src={resultActive} alt="result-active" />
	}
];
